import { render, staticRenderFns } from "./Baby.vue?vue&type=template&id=61658c06"
import script from "./Baby.vue?vue&type=script&lang=js"
export * from "./Baby.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports